import LandscapeView from 'pages/landscape'
import { useEffect, useState } from 'react'

const OrientationGuard = ({ children }) => {
  const [isLandscape, setIsLandscape] = useState(false)

  useEffect(() => {
    checkOrientation()
    window.addEventListener('resize', () => {
      checkOrientation()
    })
    return () => window.removeEventListener('resize', () => {})
  }, [])
  const checkOrientation = () => {
    if (window.matchMedia('(orientation: portrait)').matches) {
      setIsLandscape(false)
    } else {
      setIsLandscape(true)
    }
  }
  return isLandscape ? <LandscapeView /> : children
}

export default OrientationGuard
